import { Category } from '@services/categories/interfaces/categories.interfaces';
import { Mock } from '@shared/interfaces/mock.interface';

import { CDN_MOCKS_URL } from '@constants/constants';

export const CATEGORIES_MOCK: Category[] = [
  {
    id: '1',
    name: 'Merchandising',
    imageUrl: `${CDN_MOCKS_URL}merchandising.webp`,
    slug: 'merchandising',
    parentId: null,
  },
  {
    id: '2',
    name: 'Regalería',
    imageUrl: `${CDN_MOCKS_URL}regaleria.avif`,
    slug: 'regaleria',
    parentId: null,
  },
  {
    id: '3',
    name: 'Juguetería',
    imageUrl: `${CDN_MOCKS_URL}jugueteria.jpg`,
    slug: 'jugueteria',
    parentId: null,
  },
  {
    id: '4',
    name: 'Decohogar',
    imageUrl: `${CDN_MOCKS_URL}decohogar.webp`,
    slug: 'decohogar',
    parentId: null,
  },
  {
    id: '5',
    name: 'Mini macetas con o sin suculentas',
    imageUrl: `${CDN_MOCKS_URL}mini-macetas.webp`,
    slug: 'mini-macetas-con-o-sin-suculentas',
    parentId: '4',
  },
  {
    id: '6',
    name: 'Mandalas vivos con suculentas',
    imageUrl: `${CDN_MOCKS_URL}mandalas-vivos.webp`,
    slug: 'mandalas-vivos-con-suculentas',
    parentId: '4',
  },
  {
    id: '7',
    name: 'Día del Niño',
    imageUrl: `${CDN_MOCKS_URL}regaleria.avif`,
    slug: 'dia-del-nino',
    parentId: '2',
  },
];

export const GET_CATEGORIES_MOCK: Mock = {
  success: [
    {
      response: CATEGORIES_MOCK,
    },
  ],
  failures: [
    {
      response: { message: 'Error cargando categorías' },
    },
  ],
};

export const CREATE_CATEGORY_MOCK: Mock = {
  success: [
    {
      response: {
        id: '99',
        name: 'Nueva categoría',
        slug: 'nueva-categoria',
        parentId: null,
        imageUrl: null,
      },
    },
  ],
  failures: [
    {
      response: {
        code: 20001,
        message: 'Ya existe una categoría con ese nombre',
        statusCode: 409,
      },
    },
  ],
};

export const UPDATE_CATEGORY_MOCK: Mock = {
  success: [
    {
      response: {
        id: '1',
        name: 'Merchandising actualizado',
        slug: 'merchandising-actualizado',
        parentId: null,
        imageUrl: null,
      },
    },
  ],
  failures: [
    {
      response: {
        code: 20002,
        message: 'Categoría no encontrada',
        statusCode: 404,
      },
    },
  ],
};

export const DELETE_CATEGORY_MOCK: Mock = {
  success: [
    {
      response: undefined,
    },
  ],
  failures: [
    {
      response: {
        code: 20003,
        message: 'No se puede eliminar: hay productos asociados',
        products: ['Producto demo 1', 'Producto demo 2'],
        statusCode: 409,
      },
    },
  ],
};
